import { z } from 'zod'
import { apiIdSchema } from '@/shared/schemas/ids.schema'

export const userProfileDataSchema = z.object({
  id: apiIdSchema,
  name: z.string(),
  email: z.string().email(),
  phone: z.string().nullable().optional(),
  matricule: z.string().nullable().optional(),
  anciennete_date: z.string().nullable().optional(),
  contrat_type: z.string().nullable().optional(),
  statut: z.string(),
  is_active: z.boolean(),
  email_notification: z.enum(['daily', 'weekly', 'none']).nullable().optional(),
  onboarded_at: z.string().nullable().optional(),
  cookie_consent: z
    .object({
      analytics: z.boolean(),
      functional: z.boolean(),
      marketing: z.boolean().optional(),
      consented_at: z.string(),
      legal_page_version_id: z.string().nullable().optional(),
    })
    .nullable()
    .optional(),
  quotient_familial: z
    .object({
      declared: z.number().int().nullable(),
      declared_at: z.string().nullable(),
      status: z.enum(['declared', 'verified']).nullable(),
      valid_until: z.string().nullable(),
    })
    .nullable()
    .optional(),
  roles: z.array(z.string()).default([]),
})

export const meProfileResponseSchema = z.object({
  data: userProfileDataSchema,
})

export type UserProfileData = z.infer<typeof userProfileDataSchema>
